import React, { useState, useEffect, useRef } from "react";
import SideBar from "../../Components/Navbar/Sidebar";
import "./Permission.css";
import { toast, ToastContainer } from "react-toastify";
import instance from "../../Components/Apis/axios";
import { useLocation, useNavigate } from "react-router-dom";

const Permission = () => {
  const navigation = useNavigate();
  let locations = useLocation();
  const path = locations.pathname;
  const [roleList, setRoleList] = useState([]);
  const [newRole, setNewRole] = useState([]);
  const [permission, setPermission] = useState([]);
  const [data, setUser] = useState([]);
  const [hrole, setHrole] = useState("");
  const [exist, setExist] = useState(true);

  const handleClick = (event) => {
    let data = [...permission];
    data.forEach((element) => {
      if (event.currentTarget.checked) {
        if (element.permissionid == event.currentTarget.id) {
          element[event.currentTarget.value] = 1;
          setPermission(data);
        }
      } else {
        if (element.permissionid == event.currentTarget.id) {
          element[event.currentTarget.value] = 0;
          setPermission(data);
        }
      }
    });
  };

  const addrole = async (e) => {
    e.preventDefault();
    const { data } = await instance.post(
      `permission/createPermission?path=${path}`,
      {
        role: newRole,
      }
    );
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      toast("Role created successfully");
      getRoles();
      setNewRole([]);
    }
  };

  async function changeFunc(e) {
    if (e === "admin") {
      const { data } = await instance.post(
        `permission/getPermissions?path=${path}`,
        {
          role: 1,
        }
      );
      if (data.message == "You are not authorized for this page") {
        navigation("/");
      } else {
        setPermission(data);
      }
    } else {
      const { data } = await instance.post(
        `permission/getPermissions?path=${path}`,
        {
          role: e.target.value,
        }
      );
      if (data.message == "You are not authorized for this page") {
        navigation("/");
      } else {
        setPermission(data);
      }
    }
  }

  let selectUser = [];
  const handleUser = (e) => {
    selectUser.push(e.target.value);
  };

  async function getUsers(e) {
    const { data } = await instance.post(`permission/getUser?path=${path}`, {
      role: e.target.value,
    });
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      setUser(data);
      setHrole(e.target.value);
    }
  }
  const updateRole = async (e) => {
    e.preventDefault();

  
    const { data } = await instance.post(
      `permission/updateStaffPermission?path=${path}`,
      {
        permission: permission,
        role: hrole ? hrole : 1,
        user_id: selectUser,
      }
    );
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    }else {
      toast("Permission update successfully")
    }
  };

  const getRoles = async () => {
    const { data } = await instance.get(`staff/rolePermission?path=${path}`);
    if (data.message == "You are not authorized for this page") {
      navigation("/");
    } else {
      setRoleList(data);
    }
  };

  useEffect(() => {
    getRoles();
    changeFunc("admin");
  }, []);

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages">
        <div className="page-title">
          <h2>Permission</h2>
        </div>
        <div className="permissionFilters">
          <div className="permissionFilter"></div>
          <div className="permissionRole">
            Select Existance Role From List
            <select
              className="form-select"
              aria-label="Default select example"
              onChange={(e) => {
                changeFunc(e);
                getUsers(e);
              }}
            >
              {roleList.length > 0 &&
                roleList.map((obj, i) => (
                  <option value={obj.roleid}>{obj.name}</option>
                ))}
            </select>
          </div>
          <div className="newRole ">
            <form onSubmit={addrole}>
            <div className="d-flex">
            <input
                className="input ms-0"
                type="text"
                name="text"
                placeholder="Create a new role"
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
                style={{
                  width: "30%",
                  height:"20%",
                  border: "1px solid rgba(0,0,0,0.1)",
                  padding: "10px",
                }}
              />
              <input type="submit" text="sumbit" className="my-2 mb-4 p-2" />
              <ToastContainer />
            </div>
             
            </form>
          </div>
        </div>

        <div>
          <form onSubmit={updateRole}>
            <table className="table table-boarder table-hover table-striped  table-sm">
              <thead className="thead-dark">
                <tr>
                  {/* <th>ID</th> */}
                  <th>Permission Name</th>
                  <th>Can_View</th>
                  <th>Can_View_Own</th>
                  <th>Can_Edit</th>
                  <th>Can_Create</th>
                  <th>Can_Delete</th>
                </tr>
              </thead>
              <tbody>
                {permission.length > 0 &&
                  permission.map((item, i) => (
                    <tr key={i}>
                      {/* <td>{i + 1}</td> */}
                      <td>{item.name}</td>
                      <td>
                        <input
                          type="checkbox"
                          id={item.permissionid}
                          value="can_view"
                          checked={item.can_view}
                          onChange={handleClick}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          id={item.permissionid}
                          value="can_view_own"
                          checked={item.can_view_own}
                          onChange={handleClick}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          id={item.permissionid}
                          value="can_edit"
                          checked={item.can_edit}
                          onChange={handleClick}
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          value="can_create"
                          id={item.permissionid}
                          checked={item.can_create}
                          onChange={handleClick}
                        />{" "}
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          value="can_delete"
                          id={item.permissionid}
                          checked={item.can_delete}
                          onChange={handleClick}
                        />
                      </td>
                    </tr>
                  ))}
                <input
                  type="submit"
                  value="Change Permission"
                  style={{ padding: "10px", margin: "45px 0 0 0" }}
                />
              </tbody>
            </table>

          </form>
        </div>
      </div>
    </div>
  );
};

export default Permission;
